import { forwardRef, HTMLProps, memo } from 'react';

export type VideoPlayerProps = Pick<HTMLProps<HTMLDivElement>, 'id' | 'className' | 'onClick'>;

const VideoPlayer = forwardRef<HTMLDivElement, VideoPlayerProps>((props, ref) => <div ref={ref} {...props} />);

const MemoizedVideoPlayer = memo(VideoPlayer);

export default MemoizedVideoPlayer;
